/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
// @mui
import { Button, Grid, Stack, Typography } from '@mui/material';
// components
import NextLink from 'next/link';
import { useDispatch, useSelector } from 'react-redux';
import Iconify from '../../components/Iconify';
import useLocales from '../../hooks/useLocales';
import { getSchools } from '../../redux/slices/hackerthon/hackerthon.tag';
import { TagItemStyle1 } from '../tag/TagItem';
// ----------------------------------------------------------------------

export default function SchoolTags() {
  const dispatch = useDispatch();
  const { translate } = useLocales();

  const { schools } = useSelector(state => state.hackerthonTag);

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(getSchools());
    }, 500);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <Grid container >
      <Grid item xs={12}>
        <Typography variant="subtitle2">- {translate("label.school")}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container>
          {schools.map((tag, index) => (
            <Grid item xs={12} sm={6} md={3} key={tag.id}>
              <TagItemStyle1 tag={tag} index={index} />
            </Grid>
          ))}
        </Grid>
        <Stack alignItems={"center"} my={1.5}>
          <NextLink href={`/explorer/school`} passHref>
            <Button size='small' variant='outlined' startIcon={<Iconify icon={"solar:arrow-right-broken"} sx={{ width: 20 }} />}>
              <Typography variant="body2">{translate("button.more")}</Typography>
            </Button>
          </NextLink>
        </Stack>
      </Grid>
    </Grid >
  );
}